import React from 'react';
import TimelineContent from "./timeline-content.jsx";

const ReportContent = ({ data, collapsed, printOptions, boName, boId, individualList }) => {

    return (
        <>
            <TimelineContent key={`timeline-${collapsed}`} data={data} boName={boName} printOptions={printOptions} boId={boId} individualList={individualList}/>
        </>
    );
};

export default ReportContent;